import * as React from 'react';
import {ErrorAlert} from '../common/ErrorAlert';
import {ErrorResponse, Item} from '../api/dtos/dtos';
import {RouteComponentProps, withRouter} from 'react-router';
import furoApi from '../api/FuroApi';
import ItemForm from './ItemForm';
import {CURRENCY_EUR} from '../utils/currency-utils';
import {now, toIsoDateString} from '../utils/date-utils';
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../app/ApplicationContext';
import {showSaveConfirm, showSaveSuccessNotification} from 'src/utils/dialogs';

interface CreateItemPageState {
  categories: string[];
  error?: ErrorResponse;
}

class CreateItemPage extends React.Component<RouteComponentProps<{}>, CreateItemPageState> {

  public readonly loadingHandler?: LoadingOverlayHandler;

  constructor(props: RouteComponentProps<{}>) {
    super(props);
    this.state = {
      categories: [],
    };
  }

  public componentDidMount() {
    this.reload();
  }

  public render() {
    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <ItemForm
          categories={this.state.categories}
          editable={true}
          onRefreshExchangeRate={this.refreshExchangeRate}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel}
        />
        <ErrorAlert style={{marginTop: '16px'}} error={this.state.error}/>
      </>
    );
  }

  private onApiError = (error: ErrorResponse) => this.setState({error});

  private reload = () => {
    this.loadCategories();
  };

  private refreshExchangeRate = (): Promise<number | void> => {
    const promise = furoApi.currency.getRate(CURRENCY_EUR, toIsoDateString(now()))
      .then(response => response.rate)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
    return promise;
  };

  private loadCategories = () => {
    const promise = furoApi.items.getCategories()
      .then(response => {
        this.setState({
          categories: response.categories,
          error: undefined,
        });
      })
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onFormCancel = () => {
    this.props.history.goBack();
  };

  private onFormSubmit = (item: Item) => {
    showSaveConfirm(() => this.saveFormValues(item));
  };

  private saveFormValues = (item: Item) => {
    const promise = furoApi.items.create(item)
      .then(() => {
        showSaveSuccessNotification();
        this.props.history.goBack();
      })
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };
}

export default withRouter(CreateItemPage);




// WEBPACK FOOTER //
// ./src/item-details/CreateItemPage.tsx